export const FixIDS = {

  Role: { List: 1, Add: 2, Edit: 3, Delete: 4 },
  User: { List: 5, Add: 6, Edit: 7, Delete: 8 },
  Country: { List: 9, Add: 10, Edit: 11, Delete: 12 },
  State: { List: 13, Add: 14, Edit: 15, Delete: 16 },
  City: { List: 17, Add: 18, Edit: 19, Delete: 20 },
  Pincode: { List: 21, Add: 22, Edit: 23, Delete: 24 },
  Subscription: { List: 25, Add: 26, Update: 27, Delete: 28, History: 29, Buy: 30 },
  Coupons: { List: 31, Add: 32, Edit: 33, Delete: 34 },
  Category: { List: 35, Add: 36, Edit: 37, Delete: 38 },

  Product: { List: 39, Add: 40, Edit: 41, Delete: 42 },
  Orders: { List: 43, Add: 44, Edit: 45, Delete: 46 },

  About_Us: { List: 47, Add: 48, Edit: 49, Delete: 50 },

  AppSetup: { List: 51, Add: 52, Edit: 53, Delete: 54 },

  Shopkeeper: { List: 55, Add: 56, Edit: 57, Delete: 58 },
  Party: { List: 59, Add: 60, Edit: 61, Delete: 62 },
  Invoice: { List: 63, Add: 64, Edit: 65, Delete: 66 },

  Dashboard: { Admin: 67, Shopkeer: 68 },
  BusinessType: { List: 69, Add: 70, Edit: 71, Delete: 72 },
  TaxPercent: { List: 73, Add: 74, Edit: 75, Delete: 76 },
  Unit: { List: 77, Add: 78, Edit: 79, Delete: 80 },
  Banner: { List: 81, Add: 82, Edit: 83, Delete: 84 },
  CreditDays: { List: 85, Add: 86, Edit: 87, Delete: 88 },
  ExpenseType: { List: 89, Add: 90, Edit: 91, Delete: 92 },
  Expense: { List: 93, Add: 94, Edit: 95, Delete: 96 },
  Vendor: { List: 97, Add: 98, Edit: 99, Delete: 100 },
  Report: { List: 101, Add: 102, Edit: 103, Delete: 104 },

};

export const usersIDS = {
  admin: 1,
  Owner: 2,
  Tenant: 3,
};

export const orderStatus = {

  OrderRequested: 1,
  OrderReceived: 2,
  CancelOrder: 3,

};


export const CouponType = {
  FixedAmount: 1,
  Percentage: 2,
  FreeShipping: 3,
  BuyOneGetOne: 4,
  FreeGift: 5,
};
